import { render, staticRenderFns } from "./SignupHeaderSection.vue?vue&type=template&id=01439bcc&scoped=true"
import script from "./SignupHeaderSection.vue?vue&type=script&lang=ts"
export * from "./SignupHeaderSection.vue?vue&type=script&lang=ts"
import style0 from "./SignupHeaderSection.vue?vue&type=style&index=0&id=01439bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01439bcc",
  null
  
)

export default component.exports